import { Container, Grid, Typography, Stack } from "@mui/material";
import { Box } from "@mui/system";
import BG from "./background.svg";
import IMGE from "./circle.svg";
import TL from "./topLeft.svg";
import BR from "./bottomRight.svg";
import MOON from "./MOON.png";
import SATURN from "./SATURN.png";
import STARS from "./STARS.png";
import SUN from "./SUN.png";
import NEPTUNE from "./NAPTUNE.png";
import Chris_Caudill from "./Chris_Caudill.png";

export default () => {
  const sectionHeading = "OUR TEAM";
  const dataSet = [
    {
      img: SUN,
      name: "Richard",
      power: "Chief Executive Officer (CEO)",
      about:
        "Richard has been involved with Blockchain technology for the past 5 years. He is a full time Security Engineer that has been involved with Fortune 500 companies running vulnerability assessments and improving security postures for their environments. Being Rugged on more than one occasion, Richards Goal for Solar is to prevent all the scams on the Ethereum and Binance chain migrating to Solana. Solars goal is to give investors a peace of mind by making Defi on Solana safe.",
    },
    // {
    //   img: Chris_Caudill,
    //   name: "Crypto Chris",
    //   power: "Digital Hype Man",
    //   about:
    //     "Only creates digital content for Community driven Crypto projects he truly believes",
    //   mail: (
    //     <i
    //       style={{ fontSize: "26px", color: "#26D2D1", marginLeft: "30px" }}
    //       class="fas fa-envelope"
    //     ></i>
    //   ),
    //   twitter: (
    //     <i
    //       style={{ fontSize: "26px", color: "#26D2D1" }}
    //       class="fab fa-twitter"
    //     ></i>
    //   ),
    // },
    {
      img: MOON,
      name: "Ian",
      power: "Chief Marketing Officer (CMO)",
      about:
        "Strong background in Digital Marketing and Sales at both the business and consumer level. Strives to bring integrity and structure to Defi in order to achieve sustainability and fair chance profits for investors",
    },
    {
      img: SATURN,
      name: "John",
      power: "Chief Operating Officer (COO)",
      about:
        "Extensive and strong background in business management, marketing and sales in various types of businesses. Aspires to legitimize DeFi and bring it to the masses.",
    },
    {
      img: NEPTUNE,
      name: "Neptune",
      power: "Sr Blockchain Developer",
      about:
        "Extensive knowledge of programming languages used for blockchain development and experience in cryptography. An outstanding blockchain developer expertise into secure, fast, and efficient digital Assets.",
    },
    {
      img: STARS,
      name: "Stars",
      power: "Investors",
      about:
        "That is you as the investors – Without your support and dedication there would be no Solar Dex. We appreciate you and your time and commitment to the Solana ecosystem",
    },
  ];

  return (
    <Box pt={15} id="ourTeam">
      <Container sx={{ zIndex: "1" }}>
        <Box sx={{ position: "relative", textAlign: "center" }} mb={10}>
          <Box>
            {" "}
            <span className="textStroke">
              <Typography
                color="white"
                fontSize={{ xs: "31px", sm: "50px", md: "74px" }}
                sx={{ letterSpacing: "0.12em" }}
              >
                {sectionHeading}
              </Typography>
            </span>
          </Box>
          <Box
            sx={{
              position: "absolute",
              top: "10%",
              right: 0,
              left: 0,
              margin: "auto",
            }}
          >
            <Typography
              color="white"
              fontSize={{ xs: "25px", sm: "40px", md: "64px" }}
              sx={{ letterSpacing: "0.12em" }}
            >
              {sectionHeading}
            </Typography>
          </Box>
        </Box>
      </Container>
      <Box
        sx={{
          backgroundImage: `url(${BG})`,
          backgroundRepeat: "repeat-x",
          backgroundPosition: "center center",
        }}
      >
        <Container>
          {/* 2 wala container */}
          <Grid
            container
            justifyContent={{ xs: "center", md: "space-around" }}
            mt={10}
          >
            {dataSet.map((obj, indx) => {
              return indx <= 1 ? (
                <>
                  <Grid item xs={12} md={4} lg={4} mb={5}>
                    <Box
                      sx={{ position: "relative", margin: "auto" }}
                      width={{ xs: "95%", sm: "370px" }}
                    >
                      <img
                        src={TL}
                        style={{ position: "absolute", top: "0", left: "0" }}
                      />
                      <img
                        src={BR}
                        style={{
                          position: "absolute",
                          bottom: "0",
                          right: "0",
                        }}
                      />
                      <Box
                        width={{ xs: "95%", sm: "360px" }}
                        sx={{
                          margin: "auto",
                          textAlign: "center",
                          color: "white",
                          background: "#190436",
                          minHeight: "690px",
                        }}
                      >
                        <img
                          src={obj.img}
                          alt={IMGE}
                          width="40%"
                          style={{ marginTop: "40px" }}
                        />
                        <Typography variant="h5" mt={2} mb={1}>
                          {obj.name}
                        </Typography>
                        <Typography paragraph>{obj.power}</Typography>
                        <Box textAlign="center" width="100%">
                          <a
                            href="https://twitter.com/chris_caudill?s=21"
                            target="_blank"
                          >
                            {obj.twitter ? obj.twitter : null}
                          </a>
                          <a
                            href="CryptoChristopher4@gmail.com"
                            target="_blank"
                          >
                            {obj.mail ? obj.mail : null}
                          </a>
                        </Box>
                        <Typography
                          width="80%"
                          margin="50px auto 0px auto"
                          textAlign="justify"
                          pb={3}
                        >
                          {obj.about}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>{" "}
                </>
              ) : null;
            })}
          </Grid>

          {/* 3 wala container */}
          <Grid container justifyContent={{ xs: "center", md: "space-around" }}>
            {dataSet.map((obj, indx) => {
              return indx > 1 ? (
                <>
                  <Grid item xs={12} md={6} lg={4} mb={5}>
                    <Box
                      sx={{ position: "relative", margin: "auto" }}
                      width={{ xs: "95%", sm: "370px" }}
                    >
                      <img
                        src={TL}
                        style={{ position: "absolute", top: "0", left: "0" }}
                      />
                      <img
                        src={BR}
                        style={{
                          position: "absolute",
                          bottom: "0",
                          right: "0",
                        }}
                      />
                      <Box
                        width={{ xs: "95%", sm: "360px" }}
                        sx={{
                          margin: "auto",
                          textAlign: "center",
                          color: "white",
                          background: "#190436",
                          minHeight: "530px",
                        }}
                      >
                        <img
                          src={obj.img}
                          alt={IMGE}
                          width="40%"
                          style={{ marginTop: "40px" }}
                        />
                        <Typography variant="h5" mt={2} mb={1}>
                          {obj.name}
                        </Typography>
                        <Typography paragraph>{obj.power}</Typography>

                        <Typography
                          width="80%"
                          margin="50px auto 0px auto"
                          textAlign="justify"
                          pb={3}
                        >
                          {obj.about}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>{" "}
                </>
              ) : null;
            })}
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};
